<template>
    <div class="col-md-12">
        <div class="flash-message">
            <FlashMessage :position="'top'"></FlashMessage>
        </div>
        <div class="">
            <div class="h2" v-if="type === driverTypeExternal">Resources</div>
            <div>
                <div class="row" v-if="type === driverTypeExternal">
                    <div class="col-md-12 mb-3">
                        <div @click="toggleModal"
                             class="btn btn-success float-right d-flex align-items-center"
                             title="Create booking">
                            <span class="material-icons-outlined cursor-pointer mr-1">post_add</span>
                            <span>Create external Driver</span>
                        </div>
                    </div>
                </div>
                <div class="h2" v-if="type === driverTypeExternal">External drivers</div>
                <div class="h2" v-if="type === driverTypeInternal">Internal drivers</div>
                <form @submit.prevent="deleteDrivers">
                    <div class="position-relative pagination-control">
                        <data-table
                            :url="url"
                            :filters="filters"
                            :columns="columns"
                            :per-page="perPage"
                            :classes="classes"
                            :order-by="orderBy"
                            :order-dir="orderDir"
                            :meta="columns.meta"
                        >
                            <div slot="filters" slot-scope="{ tableFilters, perPage, drivers }">
                                <div class="row my-3 d-flex justify-content-end align-items-left">
                                    <div class="col-md-3">
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                            <button class="btn-sm bg-transparent border-0 d-flex align-items-center">
                                                <span class="material-icons-outlined cursor-pointer">search</span>
                                            </button>
                                            <input name="name" v-model="filters.search"
                                                   class="form-control form-control border-0 py-0 pl-0 shadow-none form-input"
                                                   placeholder="Search drivers"/>
                                        </div>
                                    </div>
                                    <div class="col-md-9">
                                    </div>
                                </div>
                                <br/>
                            </div>
                            <thead class="clickable-header" slot="header" slot-scope="{ tableFilter }">
                            <tr>
                                <th></th>
                                <th @click="sort(column.name)" v-if="column.label!==''"
                                    v-for="column in columns">
                                    <span> {{ column.label }} </span>
                                </th>
                            </tr>
                            </thead>
                            <tbody slot="body" slot-scope="{ data }">
                            <tr
                                :key="driver.id"
                                v-for="(driver,key) in data">
                                <td
                                    :key="column.name"
                                    v-for="column in columns"
                                >
                                    <data-table-cell
                                        :value="driver"
                                        :name="column.name"
                                        :meta="column.meta"
                                        :comp="column.component"
                                        :classes="column.classes">
                                    </data-table-cell>

                                    <slot v-if="column.label === ''">
                                        <input type="checkbox"
                                               v-model="drivers[driver.id]"
                                        >
                                    </slot>

                                    <slot v-if="column.label === 'Edit'">
                                        <a :href="`/drivers/${driver.id}/edit`" title="Edit Driver">
                                            <span class="material-icons-outlined cursor-pointer mr-1">edit</span>
                                        </a>
                                    </slot>
                                </td>
                            </tr>
                            </tbody>
                        </data-table>
                    </div>
                    <br/>
                    <div class="d-flex">
                        <div>
<!--                            <div-->
<!--                                @click="saveDriverChanges()"-->
<!--                                class="btn btn-primary d-flex align-items-center float-left"-->
<!--                                title="Save changes">-->
<!--                                <span class="">Save changes</span>-->
<!--                            </div> &nbsp;-->
                            <div
                                @click="deleteDrivers()"
                                class="btn btn-primary d-flex align-items-center float-left button-delete-driver"
                                title="Delete booking">
                                      <span class="material-icons-outlined cursor-pointer mr-1"
                                            title="delete">delete</span>
                                <span class="">Delete drivers</span>
                            </div>
                        </div>
                        <div>
                            <label class="pl-2">Drivers per page:</label>
                            <div class="d-inline-flex center bg-white border rounded-lg div-focus border-2">
                                <select class="form-control bg-white border-0 py-0 shadow-none"
                                        v-model="filters.length"
                                        style="width: 150px;">
                                    <option
                                        :key="index"
                                        :value="records"
                                        v-for="(records, index) in perPage">
                                        {{ records }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </form>
                <br/>
                <br/>
<!--                <vehicle-data-table></vehicle-data-table>-->
                <company-names
                    :company-names="companyNames"
                    :type="type"
                    :driver-type-external="driverTypeExternal"
                    :driver-type-internal="driverTypeInternal"
                    @getCompanyNames="getCompanyNames"
                ></company-names>
            </div>
        </div>
        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalInterval}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Add new driver</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModal"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="addNewDriver">
                            <div class="form-group">
                                <label for="new-driver-name">
                                    <strong>Name</strong>
                                </label>
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                    <input type="text"
                                           required
                                           autocomplete="none"
                                           class="form-control  border-0 py-0 shadow-none form-input"
                                           placeholder="Name"
                                           id="new-driver-name"
                                           v-model="newDriver.name"
                                    >
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="new-driver-company">
                                    <strong>Company</strong>
                                </label>
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                    <select
                                        v-model="newDriver.company_name_id"
                                        id="new-driver-company"
                                        class="form-control">
                                        <option :value="companyName.id" v-for="(companyName, index) in companyNames">
                                            {{ companyName.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="new-driver-phone">
                                    <strong>Phone</strong>
                                </label>
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                    <input type="text"
                                           autocomplete="none"
                                           class="form-control  border-0 py-0 shadow-none form-input"
                                           placeholder="Phone"
                                           id="new-driver-phone"
                                           v-model="newDriver.phone"
                                    >
                                </div>
                            </div>

                            <button class="btn btn-primary" @click="validation()">
                                Save
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalInterval" class="modal-backdrop fade show"></div>

    </div>
</template>

<script>
import VehicleDataTable from "./VehicleDataTable";
import CompanyNames from "./CompanyNames";
import companyNamesMixin from "../mixins/companyNamesMixin";

export default {
    name: "DriverDataTable",
    components: {VehicleDataTable, CompanyNames},
    mixins: [companyNamesMixin],
    props: {
        url: {type: String, required: true},
        type: {type: Number, required: true},
        driverTypes: {type: Object, required: true},
        driverTypeExternal: {type: Number, required: true},
        driverTypeInternal: {type: Number, required: true},
    },
    data() {
        let columns = [
                {
                    label: '',
                    id: '',
                    orderable: false,
                },
                {
                    label: 'VM',
                    name: 'name',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'Company',
                    name: 'company',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Phone',
                    name: 'phone',
                    orderable: false,
                    searchable: true,
                },
            ];
        if (this.type == this.driverTypeExternal) {
            columns.push(
                {
                    label: 'Edit',
                    id: 'edit',
                    orderable: false,
                }
            )
        }
        return {
            driverList: [],
            drivers: [],
            currentDrivers: [],
            orderBy: 'id',
            orderDir: 'desc',
            search: '',
            perPage: [100, 10, 25, 50],
            filters: {
                search: '',
                length: 100,
                column: 'id',
                dir: 'desc',
                type: this.type,
            },
            loading: false,
            columns: columns,
            pagination: {
                align: "right",
                meta: {to: 1, from: 1}
            },
            classes: {
                'table-container': {
                    'justify-center': true,
                    'w-full': true,
                    'flex': true,
                    'rounded-lg': true,
                    'mb-4': true,
                    'shadow-md': true,
                    'border': true,
                    'overflow-hidden': true
                },
                table: {
                    'text-left': true,
                    'w-full': true,
                    'border-collapse': true,
                    'table': true,
                    'table-striped': true,
                    'border': false,
                    'mb-0': true
                },
                't-head': {
                    'text-grey-dark': true,
                    'bg-black': true,
                    'border-grey-light': true,
                    'py-4': true,
                    'px-6': true,
                    'border': false,
                    'bg-white': true,
                },
                "t-body": {
                    'bg-grey-darkest': true,
                    'border-0': true,
                },
                "th": {
                    'border-left-0': true,
                    'border-right': true,
                    'border-bottom-0': true,
                    'border-top-0': true,
                    'shadow-sm': true,
                    'position-relative': true,
                    'font-weight-semi-bold': true,
                    'h6': true,
                    'text-left': true,
                },
                "td": {
                    'py-1': true,
                    'border-0': true,
                    'laravel-vue-datatable-td': false,
                }
            },
            selected: [],
            allSelected: false,
            activeModalInterval: false,
            show: false,
            isSubmit: false,
            newDriver: {'type': this.driverTypeExternal},
            warehouses: {},
            fileName: '',
            attachment: '',
            companyNames: [],
        }
    },
    methods: {
        toggleModal() {
            const body = document.querySelector("body");
            this.activeModalInterval = !this.activeModalInterval;
            this.activeModalInterval
                ? body.classList.add("modal-open")
                : body.classList.remove("modal-open");
            setTimeout(() => (this.show = !this.show), 10);
        },
        validation() {
            this.isSubmit = true;
        },
        addNewDriver: function () {
            axios.post(`/drivers`, this.newDriver).then((response) => {
                window.location.href = `/drivers-and-companies`;
            }).catch(err => {
                const msg = err.response.data.message || 'failed to create new driver';
                alert(msg)
            })
        },
        deleteDrivers() {
            axios.post(`/delete-multiple-drivers`, this.drivers).then((response) => {
                window.location.href = `/drivers-and-companies`;
            }).catch(err => console.log(err))
        },
        async selectAll(event) {
            if (event.target.checked) {
                if (this.allSelected) {
                    Object.entries(this.currentDrivers).forEach(entry => {
                        const [key, value] = entry;
                        this.drivers[key] = true;
                    });
                }
            } else {
                this.drivers = {};
            }
        },
        sort(column) {
            if (column) {
                const dir = this.filters.dir === 'desc' ? 'asc' : 'desc';
                this.$set(this.filters, 'column', column);
                this.$set(this.filters, 'dir', dir);
            }

        }
    },
    created() {
        this.getCompanyNames(this.type);
    },
}
</script>

<style scoped>
.import-driver {
    margin-left: 20px;
    margin-right: 20px;
}

.button-delete-driver {
    margin-left: 20px;
    background-color: red !important;
    border-color: red !important;
}

select option:disabled {
    color: #999;
}
</style>
